export default __webpack_public_path__ + "static/RH-logo-horizontal-2dc1a297b207fd7e4c2a4c14a2f8799d.svg";